
//cookie
var cookie={
	setcookie: function(name, value, Days, path) {
        if (typeof(Days) == 'undefined') {
            Days = 24;
        }
        if (typeof(path) == 'undefined') {
            path = 'path=/;';
        } else {
            path = '';
        }
        var date = new Date(); 
        date.setTime(date.getTime() + Days * 60 * 60 * 1000);
        
        // 获取当前域名
        var domain = window.location.hostname;
        
        // 添加点号前缀
        var cookieDomain = '.' + domain;
        var value=encodeURIComponent(value);
        document.cookie = name + "=" + value + ";" + path + "expires=" + date.toGMTString() + ";domain=" + cookieDomain;
    },    
	getcookie: function(name) {
        var currentDomain = window.location.hostname;
        var cookies = document.cookie.split(';');
        var cookieValue = null;
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');

            if (cookie.substring(0, name.length + 1) == (name + '=')) {
                // 获取 cookie 的 value 部分
                var cookieContent = cookie.substring(name.length + 1);

                // 尝试获取 domain 信息
                var domainMatch = /domain=([^;]*)/.exec(cookie);
                var cookieDomain = domainMatch ? domainMatch[1] : currentDomain;
                // 确保 cookieDomain 和 currentDomain 完全匹配
                if (cookieDomain === currentDomain || cookieDomain === '.' + currentDomain) {
                    cookieValue = decodeURIComponent(cookieContent);
                    break;
                }
            }
        }
        return cookieValue;
    },    
    deletecookie: function(name) {
        var date = new Date();
        date.setTime(date.getTime() - (1 * 24 * 60 * 60 * 1000)); // 1 day ago
        var expires = "; expires=" + date.toUTCString();
        
        // 获取当前域名
        var domain = document.domain;
        var domainParts = domain.split('.');
    
        // 删除当前域名下的 cookie
        document.cookie = name + "=; " + expires + "; path=/; domain=" + domain;
        
        // 尝试删除带点的当前域名下的 cookie
        if (!domain.startsWith('.')) {
            document.cookie = name + "=; " + expires + "; path=/; domain=." + domain;
        }
        
        // 尝试删除不带点的父域名下的 cookie
        for (var i = 0; i < domainParts.length - 1; i++) {
            domainParts.shift(); // 去掉第一个子域
            var parentDomain = domainParts.join('.');
            document.cookie = name + "=; " + expires + "; path=/; domain=" + parentDomain;
            document.cookie = name + "=; " + expires + "; path=/; domain=." + parentDomain;
        }
    }
};
var local_store = {
    // 存储数据
    saveToLocalStorage:function (key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    // 获取数据
    getFromLocalStorage:function (key) {
        var item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    },
    // 获取数据
    removeItemLocalStorage:function (key) {
        localStorage.removeItem('myKey')
    },
};
var session_store = {
    // 存储数据
    saveToSessionStorage:function (key, value) {
        sessionStorage.setItem(key, value);
    },
    // 获取数据
    getFromSessionStorage:function (key) {
        var item = sessionStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    },
    // 获取数据
    removeItemSessionStorage:function (key) {
        sessionStorage.removeItem(key);
    }
};